import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';

import { CarouselBase } from '../carousel-base';
import { CarouselSlideDirective } from '../carousel-slide.directive';
import { carouselAnimations } from '../carousel.animation';

/**
 * Component to show a carousel
 */
@Component({
  selector: 'atx-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [carouselAnimations],
  standalone: false,
})
export class CarouselComponent<T> extends CarouselBase<T> {
  @ContentChild(CarouselSlideDirective, { read: TemplateRef })
  public slideTpl: CarouselSlideDirective;

  @HostBinding('class.centered-navigation')
  @Input()
  public centerControls = false;

  /**
   * Returns the array of visible media, based on the current position of the carousel and amount of thumbnails configured to be shown
   */
  public getIndicators() {
    return this.items.slice(this.offSet, this.offSet + this.thumbnailsNumber);
  }

  protected indexUpdated() {}
}
